import {
  Dialog,
  Box,
  Typography,
  IconButton,
  Grid,
  Card,
  CardContent,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PsychologyIcon from "@mui/icons-material/Psychology";
import { useNavigate } from "react-router-dom";
import PsychometricTestModal from "./PsychometricTestModal";
import ProfileBuildingModal from "./ProfileBuildingModal";
import { useState } from "react";
import { useEffect } from "react";
import { authFetch } from "../../../api";

const firstName = localStorage.getItem("firstName");
const OnboardingModal = ({
  open,
  onClose,
  userName = firstName ? firstName : "User",
}) => {
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(null);
  const [alreadySubmitted, setAlreadySubmitted] = useState(false);

  const fetchCheckGivenQuiz = async () => {
    try {
      const userId = localStorage.getItem("userId");
      if (!userId) return;
      const response = await authFetch("quiz/check-personality-quiz-status", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ user_id: userId }),
      });
      const data = await response.json();
      if (data?.success) {
        setAlreadySubmitted(true);
      } else {
        setAlreadySubmitted(false);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchCheckGivenQuiz();
  }, []);

  const handleStart = (card) => {
    if (card.action === "navigate") {
      navigate("/personality-quiz");
    } else if (card.action === "modal") {
      setOpenModal(card.title);
    }
  };

  const handleCloseModal = () => setOpenModal(null);

  const cards = [
    {
      title: "Personality Quiz",
      head: "Discover your passion",
      desc: "5 mins quiz to discover your core passion",
      icon: (
        <Grid>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_3373_10994)">
              <path
                d="M17.4158 2.15873C15.8311 0.656853 13.7547 -0.105897 11.5677 0.0118527C7.47942 0.230478 4.1408 3.74423 4.12505 7.8441C4.11755 9.9936 4.95792 12.0021 6.4913 13.4984C7.62792 14.6099 8.36405 16.0922 8.56505 17.6785C8.60555 17.9605 8.62505 18.2549 8.62505 18.5777V21.3752C8.62505 21.9955 9.1298 22.5002 9.75005 22.5002H14.25C14.8703 22.5002 15.375 21.9955 15.375 21.3752V18.5815C15.375 18.2605 15.3953 17.9564 15.4362 17.671C15.6315 16.0832 16.3534 14.6151 17.4694 13.5374C19.0208 12.0396 19.875 10.0289 19.875 7.87523C19.875 5.6916 19.0017 3.66173 17.4158 2.15873Z"
                fill="#FFE100"
              />
              <path
                d="M14.1705 21.8949C14.0996 21.8037 13.9905 21.7505 13.875 21.7505H10.125C10.0095 21.7505 9.90034 21.8037 9.82947 21.8949C9.75859 21.986 9.73309 22.1045 9.76122 22.2166L10.1362 23.7166C10.1778 23.8835 10.3278 24.0005 10.5 24.0005H13.5C13.6721 24.0005 13.8221 23.8835 13.8637 23.7166L14.2387 22.2166C14.2668 22.1045 14.2413 21.986 14.1705 21.8949Z"
                fill="#222222"
              />
              <path
                d="M15.3468 17.3799C15.2756 17.2977 15.1724 17.2505 15.0637 17.2505H8.93619C8.82744 17.2505 8.72431 17.2977 8.65306 17.3799C8.58181 17.462 8.54994 17.5711 8.56531 17.6787C8.60581 17.9607 8.62531 18.2551 8.62531 18.578V21.3755C8.62531 21.9957 9.13006 22.5005 9.75031 22.5005H14.2503C14.8706 22.5005 15.3753 21.9957 15.3753 21.3755V18.5817C15.3753 18.2607 15.3956 17.9566 15.4353 17.6787C15.4507 17.5711 15.4188 17.462 15.3476 17.3799H15.3468Z"
                fill="#222222"
              />
              <path
                d="M14.8125 6.75049C13.8821 6.75049 13.125 7.50724 13.125 8.43799V9.37549H10.875V8.43799C10.875 7.50724 10.1179 6.75049 9.1875 6.75049C8.25713 6.75049 7.5 7.50724 7.5 8.43799C7.5 9.36874 8.25713 10.1255 9.1875 10.1255H10.125V17.6255C10.125 17.8325 10.293 18.0005 10.5 18.0005C10.707 18.0005 10.875 17.8325 10.875 17.6255V10.1255H13.125V17.6255C13.125 17.8325 13.293 18.0005 13.5 18.0005C13.707 18.0005 13.875 17.8325 13.875 17.6255V10.1255H14.8125C15.7429 10.1255 16.5 9.36836 16.5 8.43799C16.5 7.50761 15.7429 6.75049 14.8125 6.75049ZM8.25 8.43799C8.25 7.92124 8.67075 7.50049 9.1875 7.50049C9.70425 7.50049 10.125 7.92124 10.125 8.43799V9.37549H9.1875C8.67075 9.37549 8.25 8.95474 8.25 8.43799ZM14.8125 9.37549H13.875V8.43799C13.875 7.92124 14.2958 7.50049 14.8125 7.50049C15.3292 7.50049 15.75 7.92124 15.75 8.43799C15.75 8.95474 15.3292 9.37549 14.8125 9.37549Z"
                fill="url(#paint0_linear_3373_10994)"
              />
              <path
                d="M22.5 8.32617H21C20.793 8.32617 20.625 8.15817 20.625 7.95117C20.625 7.74417 20.793 7.57617 21 7.57617H22.5C22.707 7.57617 22.875 7.74417 22.875 7.95117C22.875 8.15817 22.707 8.32617 22.5 8.32617Z"
                fill="url(#paint1_linear_3373_10994)"
              />
              <path
                d="M3 8.32617H1.5C1.293 8.32617 1.125 8.15817 1.125 7.95117C1.125 7.74417 1.293 7.57617 1.5 7.57617H3C3.207 7.57617 3.375 7.74417 3.375 7.95117C3.375 8.15817 3.207 8.32617 3 8.32617Z"
                fill="url(#paint2_linear_3373_10994)"
              />
              <path
                d="M19.4249 15.7504C19.3289 15.7504 19.2329 15.7137 19.1597 15.6405L18.0992 14.5797C17.9526 14.433 17.9526 14.1957 18.0992 14.0494C18.2459 13.9028 18.4829 13.9028 18.6295 14.0494L19.69 15.1103C19.8366 15.2569 19.8366 15.4943 19.69 15.6405C19.6169 15.7137 19.5209 15.7504 19.4249 15.7504Z"
                fill="url(#paint3_linear_3373_10994)"
              />
              <path
                d="M5.63579 1.96209C5.53979 1.96209 5.44379 1.92534 5.37066 1.85222L4.31016 0.791342C4.16354 0.644717 4.16354 0.407342 4.31016 0.261092C4.45679 0.114467 4.69416 0.114467 4.84041 0.261092L5.90091 1.32197C6.04754 1.46859 6.04754 1.70597 5.90091 1.85222C5.82779 1.92534 5.73179 1.96209 5.63579 1.96209Z"
                fill="url(#paint4_linear_3373_10994)"
              />
              <path
                d="M4.57529 15.7504C4.47929 15.7504 4.38329 15.7137 4.31016 15.6405C4.16354 15.4943 4.16354 15.2565 4.31016 15.1103L5.37066 14.0494C5.51729 13.9028 5.75429 13.9028 5.90091 14.0494C6.04754 14.1957 6.04754 14.433 5.90091 14.5797L4.84041 15.6405C4.76729 15.7137 4.67129 15.7504 4.57529 15.7504Z"
                fill="url(#paint5_linear_3373_10994)"
              />
              <path
                d="M18.3644 1.96209C18.2684 1.96209 18.1724 1.92534 18.0992 1.85222C17.9526 1.70597 17.9526 1.46859 18.0992 1.32197L19.1597 0.261092C19.3064 0.114467 19.5434 0.114467 19.69 0.261092C19.8366 0.407342 19.8366 0.644717 19.69 0.791342L18.6295 1.85222C18.5564 1.92534 18.4604 1.96209 18.3644 1.96209Z"
                fill="url(#paint6_linear_3373_10994)"
              />
              <path
                d="M20.2414 4.71002C20.0971 4.71002 19.9594 4.62602 19.8979 4.4854C19.8147 4.29565 19.9009 4.0744 20.0907 3.99152L21.4643 3.3889C21.6544 3.30565 21.8757 3.3919 21.9582 3.58165C22.0414 3.7714 21.9552 3.99265 21.7654 4.07552L20.3918 4.67815C20.3427 4.6999 20.2917 4.71002 20.2414 4.71002Z"
                fill="url(#paint7_linear_3373_10994)"
              />
              <path
                d="M2.38499 12.5446C2.24061 12.5446 2.10299 12.4606 2.04149 12.32C1.95824 12.1302 2.04449 11.909 2.23424 11.8261L3.60786 11.2235C3.79799 11.1406 4.01924 11.2265 4.10174 11.4162C4.18499 11.606 4.09874 11.8272 3.90899 11.9101L2.53536 12.5127C2.48624 12.5345 2.43524 12.5446 2.38499 12.5446Z"
                fill="url(#paint8_linear_3373_10994)"
              />
              <path
                d="M3.75824 4.71002C3.70799 4.71002 3.65661 4.6999 3.60786 4.67815L2.23424 4.07552C2.04449 3.99227 1.95824 3.7714 2.04149 3.58165C2.12474 3.3919 2.34636 3.30565 2.53536 3.3889L3.90899 3.99152C4.09874 4.07477 4.18499 4.29602 4.10174 4.4854C4.04024 4.62602 3.90261 4.71002 3.75824 4.71002Z"
                fill="url(#paint9_linear_3373_10994)"
              />
              <path
                d="M21.6147 12.5449C21.5644 12.5449 21.5134 12.5347 21.4643 12.513L20.0907 11.9104C19.9009 11.8271 19.8147 11.6062 19.8979 11.4165C19.9812 11.2271 20.2028 11.1412 20.3918 11.2237L21.7654 11.8264C21.9552 11.9096 22.0414 12.1309 21.9582 12.3202C21.8967 12.4609 21.7591 12.5449 21.6147 12.5449Z"
                fill="url(#paint10_linear_3373_10994)"
              />
              <path
                d="M15.75 18.0005H8.25C8.043 18.0005 7.875 17.8325 7.875 17.6255C7.875 17.4185 8.043 17.2505 8.25 17.2505H15.75C15.957 17.2505 16.125 17.4185 16.125 17.6255C16.125 17.8325 15.957 18.0005 15.75 18.0005Z"
                fill="#222222"
              />
              <path
                d="M15.75 20.2505H8.25C8.043 20.2505 7.875 20.0825 7.875 19.8755C7.875 19.6685 8.043 19.5005 8.25 19.5005H15.75C15.957 19.5005 16.125 19.6685 16.125 19.8755C16.125 20.0825 15.957 20.2505 15.75 20.2505Z"
                fill="#222222"
              />
            </g>
            <defs>
              <linearGradient
                id="paint0_linear_3373_10994"
                x1="7.5"
                y1="12.3755"
                x2="16.5"
                y2="12.3755"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FFB850" />
                <stop offset="0.989" stop-color="#FF8901" />
              </linearGradient>
              <linearGradient
                id="paint1_linear_3373_10994"
                x1="20.625"
                y1="7.95117"
                x2="22.875"
                y2="7.95117"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FEEC97" />
                <stop offset="0.989" stop-color="#FFC002" />
              </linearGradient>
              <linearGradient
                id="paint2_linear_3373_10994"
                x1="1.125"
                y1="7.95117"
                x2="3.375"
                y2="7.95117"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FEEC97" />
                <stop offset="0.989" stop-color="#FFC002" />
              </linearGradient>
              <linearGradient
                id="paint3_linear_3373_10994"
                x1="17.9894"
                y1="14.8452"
                x2="19.7999"
                y2="14.8452"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FEEC97" />
                <stop offset="0.989" stop-color="#FFC002" />
              </linearGradient>
              <linearGradient
                id="paint4_linear_3373_10994"
                x1="4.20029"
                y1="1.05647"
                x2="6.01079"
                y2="1.05647"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FEEC97" />
                <stop offset="0.989" stop-color="#FFC002" />
              </linearGradient>
              <linearGradient
                id="paint5_linear_3373_10994"
                x1="4.20029"
                y1="14.8452"
                x2="6.01079"
                y2="14.8452"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FEEC97" />
                <stop offset="0.989" stop-color="#FFC002" />
              </linearGradient>
              <linearGradient
                id="paint6_linear_3373_10994"
                x1="17.9894"
                y1="1.05647"
                x2="19.7999"
                y2="1.05647"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FEEC97" />
                <stop offset="0.989" stop-color="#FFC002" />
              </linearGradient>
              <linearGradient
                id="paint7_linear_3373_10994"
                x1="19.8661"
                y1="4.03352"
                x2="21.9901"
                y2="4.03352"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FEEC97" />
                <stop offset="0.989" stop-color="#FFC002" />
              </linearGradient>
              <linearGradient
                id="paint8_linear_3373_10994"
                x1="2.00961"
                y1="11.8685"
                x2="4.13361"
                y2="11.8685"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FEEC97" />
                <stop offset="0.989" stop-color="#FFC002" />
              </linearGradient>
              <linearGradient
                id="paint9_linear_3373_10994"
                x1="2.00961"
                y1="4.03352"
                x2="4.13361"
                y2="4.03352"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FEEC97" />
                <stop offset="0.989" stop-color="#FFC002" />
              </linearGradient>
              <linearGradient
                id="paint10_linear_3373_10994"
                x1="19.8661"
                y1="11.8687"
                x2="21.9901"
                y2="11.8687"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FEEC97" />
                <stop offset="0.989" stop-color="#FFC002" />
              </linearGradient>
              <clipPath id="clip0_3373_10994">
                <rect
                  width="24"
                  height="24"
                  fill="white"
                  transform="translate(0 0.000488281)"
                />
              </clipPath>
            </defs>
          </svg>
        </Grid>
      ),
      action: "navigate",
    },
    {
      title: "Psychometric Test",
      head: "Understand your personality",
      desc: "Comprehensive personality & learning analysis",
      icon: <PsychologyIcon sx={{ color: "#f28b30", fontSize: 30 }} />,
      modal: (
        <PsychometricTestModal
          open={openModal === "Psychometric Test"}
          handleClose={handleCloseModal}
        />
      ),

      action: "modal",
    },
    {
      title: "Profile Building",
      head: "Enroll & boost your skills",
      desc: "Structured programs to build your profile",
      modal: (
        <ProfileBuildingModal open={open} handleClose={handleCloseModal} />
      ),
      icon: (
        <Grid>
          <svg
            width="18"
            height="22"
            viewBox="0 0 18 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.0959 21.9073H2.74894C1.23469 21.9073 0 20.7004 0 19.1721V18.0817C0 13.1843 3.99295 9.19092 8.9224 9.19092C13.8379 9.19092 17.8448 13.1703 17.8448 18.0817V19.1721C17.8215 20.6865 16.6101 21.9073 15.0959 21.9073Z"
              fill="#572575"
            />
            <path
              d="M8.90826 8.19132C11.1778 8.19132 13.0177 6.35752 13.0177 4.09541C13.0177 1.83331 11.1778 -0.000488281 8.90826 -0.000488281C6.63868 -0.000488281 4.79883 1.83331 4.79883 4.09541C4.79883 6.35752 6.63868 8.19132 8.90826 8.19132Z"
              fill="#FFD13A"
            />
          </svg>
        </Grid>
      ),
      action: "modal",
    },
  ];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      PaperProps={{
        sx: {
          borderRadius: "16px",
          p: 4,
          boxShadow: "0 6px 20px rgba(0,0,0,0.2)",
          position: "relative",
          overflow: "visible",
        },
      }}
      BackdropProps={{
        sx: {
          backgroundColor: "rgba(0,0,0,0.3)",
          backdropFilter: "blur(6px)",
        },
      }}
    >
      {/* Close Button */}
      <IconButton
        onClick={onClose}
        sx={{
          zIndex: "2",
          position: "absolute",
          top: -16,
          right: -16,
          backgroundColor: "#CE0E00",
          color: "white",
          "&:hover": { backgroundColor: "#A50C00" },
          boxShadow: "0px 2px 6px rgba(0,0,0,0.2)",
        }}
      >
        <CloseIcon />
      </IconButton>

      {/* Heading */}
      <Box textAlign="center" mb={2}>
        <Typography
          //   variant="h5"
          fontWeight="400"
          fontSize={"32px"}
          lineHeight={"100%"}
          fontFamily={"Inter"}
          sx={{ style: "Regular" }}
          color={"#161719"}
        >
          Welcome, <span style={{ color: "#572575" }}>{userName}!</span>
        </Typography>
        <Box
          sx={{
            mt: 2,
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <Typography
            fontFamily="Inter"
            fontWeight={400}
            fontSize="16px"
            lineHeight="150%"
            letterSpacing="0px"
            textAlign="center"
            sx={{ color: "#313439", maxWidth: "517px" }}
          >
            Greatness begins with knowing yourself. Let’s uncover your strength
            and goals to unlock an Ivy-ready profile.
          </Typography>
        </Box>
      </Box>

      {/* Divider */}
      <Grid display={"flex"} justifyContent={"center"} alignItems={"center"}>
        <svg
          width="638"
          height="20"
          viewBox="0 0 638 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g opacity="0.15">
            <path
              d="M2.37779 7.74546H4.18203C4.83812 7.74546 5.3958 7.8004 5.52702 7.87889C5.52702 7.8815 5.53795 7.88281 5.55982 7.88281C5.85506 8.02409 7.46248 8.03979 8.08577 7.91813C8.64344 7.80432 9.36514 7.71406 9.82441 7.66305C9.91188 7.65258 9.98843 7.64081 10.054 7.62773H275.016C275.574 7.62773 276 7.57671 276 7.50999C276 7.4472 275.574 7.39226 275.016 7.39226H10.1525C10.0868 7.37264 9.98843 7.35302 9.82441 7.33732C9.36514 7.2863 8.64344 7.19604 8.08577 7.08223C7.46248 6.96058 5.85506 6.97627 5.55982 7.11363C5.53795 7.11624 5.52702 7.11886 5.52702 7.12148C5.3958 7.19997 4.83812 7.25491 4.18203 7.25491H2.37779C1.62328 7.25491 1 7.32947 1 7.41973V7.49822V7.58063C1 7.67089 1.62328 7.74546 2.37779 7.74546Z"
              fill="url(#paint0_linear_3173_18800)"
              stroke="url(#paint1_linear_3173_18800)"
              stroke-width="2"
            />
            <path
              d="M351.438 7.74546H353.321C354.006 7.74546 354.588 7.8004 354.725 7.87889C354.725 7.8815 354.736 7.88281 354.759 7.88281C355.067 8.02409 356.744 8.03979 357.395 7.91813C357.977 7.80432 358.73 7.71406 359.209 7.66305C359.301 7.65258 359.381 7.64081 359.449 7.62773H635.973C636.555 7.62773 637 7.57671 637 7.50999C637 7.4472 636.555 7.39226 635.973 7.39226H359.552C359.483 7.37264 359.381 7.35302 359.209 7.33732C358.73 7.2863 357.977 7.19604 357.395 7.08223C356.744 6.96058 355.067 6.97627 354.759 7.11363C354.736 7.11624 354.725 7.11886 354.725 7.12148C354.588 7.19997 354.006 7.25491 353.321 7.25491H351.438C350.65 7.25491 350 7.32947 350 7.41973V7.49822V7.58063C350 7.67089 350.65 7.74546 351.438 7.74546Z"
              fill="url(#paint2_linear_3173_18800)"
              stroke="url(#paint3_linear_3173_18800)"
              stroke-width="2"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M312.853 12.5598C312.044 12.5598 311.391 11.6821 311.391 10.5956C311.391 9.50898 312.044 8.61743 312.853 8.61743C313.672 8.61743 314.325 9.50898 314.325 10.5956C314.325 11.6821 313.672 12.5598 312.853 12.5598ZM313.672 10.5956C313.672 9.99655 313.309 9.50898 312.853 9.50898C312.407 9.50898 312.044 9.99655 312.044 10.5956C312.044 11.1946 312.407 11.6821 312.853 11.6821C313.309 11.6821 313.672 11.1946 313.672 10.5956Z"
              fill="url(#paint4_linear_3173_18800)"
              stroke="url(#paint5_linear_3173_18800)"
              stroke-width="2"
            />
            <path
              d="M312.519 18.1465C312.519 18.3833 312.674 18.5505 312.84 18.5505C313.006 18.5366 313.141 18.3416 313.141 18.1187C313.099 16.5724 313.628 14.9704 314.582 13.7166C315.391 12.6718 316.47 11.8639 317.88 11.237C320.69 10.025 323.677 10.0111 326.228 10.1504C327.731 10.2201 329.484 10.3872 331.164 10.9445C331.942 11.2091 332.719 11.5713 333.466 11.9196C334.285 12.2818 335.115 12.6579 335.975 12.9365C339.719 14.1624 343.908 13.2151 347.165 10.429C347.172 10.429 347.175 10.429 347.175 10.429C347.237 10.3594 348.834 8.91061 348.969 6.57028C349.052 5.12151 348.565 3.51951 347.725 2.47472C347.227 1.86178 346.428 1.19312 345.257 1.19312C345.028 1.19312 344.79 1.22098 344.541 1.2767C343.172 1.56924 342.104 2.93443 341.814 4.75932C341.544 6.41705 341.99 7.97726 342.975 8.85489C343.11 8.98026 343.307 8.92454 343.4 8.72951C343.494 8.53448 343.452 8.28374 343.307 8.14443C342.55 7.47577 342.208 6.24988 342.415 4.94042C342.654 3.44985 343.525 2.33542 344.634 2.0986C345.962 1.81999 346.812 2.47472 347.299 3.08766C348.108 4.07673 348.409 5.51157 348.347 6.50063C348.243 8.40911 346.885 9.67678 346.833 9.73251C343.711 12.3932 339.709 13.2987 336.121 12.1286C335.291 11.8639 334.472 11.4877 333.673 11.1256C332.906 10.7773 332.118 10.4151 331.309 10.1365C329.577 9.55141 327.783 9.39818 326.259 9.31459C325.626 9.2728 324.973 9.24494 324.299 9.24494C322.183 9.24494 319.892 9.49569 317.693 10.4569C316.179 11.1116 315.028 11.9753 314.157 13.1176C313.068 14.5385 312.467 16.3634 312.519 18.1465Z"
              fill="url(#paint6_linear_3173_18800)"
              stroke="url(#paint7_linear_3173_18800)"
              stroke-width="2"
            />
            <path
              d="M339.905 5.64911C338.868 5.64911 337.873 4.98044 336.929 3.62919C336.805 3.46202 336.815 3.18341 336.95 3.01624C337.074 2.84908 337.282 2.84908 337.406 3.03017C338.277 4.26999 339.169 4.85507 340.071 4.77149C341.637 4.61825 342.757 2.54261 342.767 2.51475C342.871 2.31972 343.078 2.27793 343.224 2.41723C343.369 2.55654 343.41 2.83515 343.296 3.03017C343.244 3.12769 341.99 5.46801 340.123 5.64911C340.047 5.64911 339.974 5.64911 339.905 5.64911Z"
              fill="url(#paint8_linear_3173_18800)"
              stroke="url(#paint9_linear_3173_18800)"
              stroke-width="2"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M340.198 9.46592C339.597 9.46592 339.109 8.82511 339.109 8.01715C339.109 7.20918 339.597 6.55444 340.198 6.55444C340.8 6.55444 341.287 7.20918 341.287 8.01715C341.287 8.82511 340.8 9.46592 340.198 9.46592ZM340.634 8.01715C340.634 7.69674 340.437 7.43206 340.198 7.43206C339.96 7.43206 339.763 7.69674 339.763 8.01715C339.763 8.33755 339.96 8.58829 340.198 8.58829C340.437 8.58829 340.634 8.33755 340.634 8.01715Z"
              fill="url(#paint10_linear_3173_18800)"
              stroke="url(#paint11_linear_3173_18800)"
              stroke-width="2"
            />
            <path
              d="M313.123 18.1465C313.123 18.3833 312.968 18.5505 312.802 18.5505C312.636 18.5366 312.501 18.3416 312.501 18.1187C312.543 16.5724 312.024 14.9704 311.06 13.7166C310.251 12.6718 309.173 11.8639 307.762 11.237C304.952 10.025 301.965 10.0111 299.414 10.1504C297.911 10.2201 296.158 10.3872 294.478 10.9445C293.701 11.2091 292.923 11.5713 292.176 11.9196C291.357 12.2818 290.527 12.6579 289.677 12.9365C285.923 14.1624 281.734 13.2151 278.478 10.429C278.471 10.429 278.467 10.429 278.467 10.429C278.405 10.3594 276.808 8.91061 276.673 6.57028C276.59 5.12151 277.078 3.51951 277.918 2.47472C278.415 1.86178 279.214 1.19312 280.386 1.19312C280.607 1.19312 280.845 1.22098 281.101 1.2767C282.47 1.56924 283.538 2.93443 283.828 4.75932C284.098 6.41705 283.652 7.97726 282.667 8.85489C282.532 8.98026 282.335 8.92454 282.242 8.72951C282.149 8.53448 282.19 8.28374 282.335 8.14443C283.092 7.47577 283.434 6.24988 283.227 4.94042C282.988 3.44985 282.117 2.33542 281.008 2.0986C279.68 1.81999 278.83 2.47472 278.343 3.08766C277.534 4.07673 277.233 5.51157 277.295 6.50063C277.399 8.40911 278.758 9.67678 278.809 9.73251C281.931 12.3932 285.934 13.2987 289.532 12.1286C290.351 11.8639 291.181 11.4877 291.969 11.1256C292.736 10.7773 293.524 10.4151 294.333 10.1365C296.065 9.55141 297.859 9.39818 299.383 9.31459C300.016 9.2728 300.669 9.24494 301.343 9.24494C303.459 9.24494 305.75 9.49569 307.949 10.4569C309.463 11.1116 310.614 11.9753 311.485 13.1176C312.574 14.5385 313.175 16.3634 313.123 18.1465Z"
              fill="url(#paint12_linear_3173_18800)"
              stroke="url(#paint13_linear_3173_18800)"
              stroke-width="2"
            />
            <path
              d="M285.774 5.64911C285.697 5.64911 285.621 5.64911 285.545 5.64911C283.679 5.46801 282.424 3.12769 282.372 3.03017C282.258 2.83515 282.3 2.55654 282.445 2.41723C282.59 2.27793 282.797 2.31972 282.901 2.51475C282.922 2.55654 284.042 4.63218 285.597 4.77149C286.499 4.84114 287.391 4.26999 288.262 3.03017C288.387 2.84908 288.594 2.84908 288.719 3.01624C288.853 3.18341 288.864 3.46202 288.739 3.62919C287.796 4.98044 286.8 5.64911 285.774 5.64911Z"
              fill="url(#paint14_linear_3173_18800)"
              stroke="url(#paint15_linear_3173_18800)"
              stroke-width="2"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M285.476 9.46592C284.874 9.46592 284.387 8.82511 284.387 8.01715C284.387 7.20918 284.874 6.55444 285.476 6.55444C286.077 6.55444 286.564 7.20918 286.564 8.01715C286.564 8.82511 286.077 9.46592 285.476 9.46592ZM285.911 8.01715C285.911 7.69674 285.714 7.43206 285.476 7.43206C285.237 7.43206 285.04 7.69674 285.04 8.01715C285.04 8.33755 285.237 8.58829 285.476 8.58829C285.714 8.58829 285.911 8.33755 285.911 8.01715Z"
              fill="url(#paint16_linear_3173_18800)"
              stroke="url(#paint17_linear_3173_18800)"
              stroke-width="2"
            />
            <path
              d="M309.319 8.65164C309.35 8.65164 311.828 9.06955 312.803 5.97698C313.778 9.06955 316.256 8.65164 316.287 8.65164C316.453 8.62377 316.578 8.40089 316.547 8.178C316.526 7.95511 316.37 7.78794 316.204 7.81581C316.09 7.84367 313.591 8.26158 313.114 4.41677C313.114 4.40748 313.114 4.40284 313.114 4.40284C313.145 4.17995 313.021 3.97099 312.855 3.9292C312.841 3.9292 312.827 3.9292 312.813 3.9292C312.806 3.9292 312.803 3.9292 312.803 3.9292C312.803 3.9292 312.8 3.9292 312.793 3.9292C312.779 3.9292 312.765 3.9292 312.751 3.9292C312.575 3.97099 312.461 4.17995 312.492 4.40284C312.492 4.40284 312.492 4.40748 312.492 4.41677C312.015 8.23372 309.516 7.84367 309.402 7.81581C309.236 7.78794 309.08 7.95511 309.059 8.178C309.028 8.40089 309.153 8.62377 309.319 8.65164Z"
              fill="url(#paint18_linear_3173_18800)"
              stroke="url(#paint19_linear_3173_18800)"
              stroke-width="2"
            />
          </g>
          <defs>
            <linearGradient
              id="paint0_linear_3173_18800"
              x1="1"
              y1="7.5"
              x2="1.17437"
              y2="19.5464"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#B5915F" />
              <stop offset="0.495" stop-color="#836944" />
              <stop offset="1" stop-color="#EAA84C" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_3173_18800"
              x1="1"
              y1="7.5"
              x2="1.17437"
              y2="19.5464"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#B5915F" />
              <stop offset="0.495" stop-color="#836944" />
              <stop offset="1" stop-color="#EAA84C" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_3173_18800"
              x1="350"
              y1="7.5"
              x2="350.167"
              y2="19.5466"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#B5915F" />
              <stop offset="0.495" stop-color="#836944" />
              <stop offset="1" stop-color="#EAA84C" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_3173_18800"
              x1="350"
              y1="7.5"
              x2="350.167"
              y2="19.5466"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#B5915F" />
              <stop offset="0.495" stop-color="#836944" />
              <stop offset="1" stop-color="#EAA84C" />
            </linearGradient>
            <linearGradient
              id="paint4_linear_3173_18800"
              x1="311.391"
              y1="10.5886"
              x2="319.974"
              y2="12.1937"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#B5915F" />
              <stop offset="0.495" stop-color="#836944" />
              <stop offset="1" stop-color="#EAA84C" />
            </linearGradient>
            <linearGradient
              id="paint5_linear_3173_18800"
              x1="311.391"
              y1="10.5886"
              x2="319.974"
              y2="12.1937"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#B5915F" />
              <stop offset="0.495" stop-color="#836944" />
              <stop offset="1" stop-color="#EAA84C" />
            </linearGradient>
            <linearGradient
              id="paint6_linear_3173_18800"
              x1="312.516"
              y1="9.87181"
              x2="398.842"
              y2="55.4293"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#B5915F" />
              <stop offset="0.495" stop-color="#836944" />
              <stop offset="1" stop-color="#EAA84C" />
            </linearGradient>
            <linearGradient
              id="paint7_linear_3173_18800"
              x1="312.516"
              y1="9.87181"
              x2="398.842"
              y2="55.4293"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#B5915F" />
              <stop offset="0.495" stop-color="#836944" />
              <stop offset="1" stop-color="#EAA84C" />
            </linearGradient>
            <linearGradient
              id="paint8_linear_3173_18800"
              x1="336.842"
              y1="3.99216"
              x2="352.702"
              y2="11.8314"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#B5915F" />
              <stop offset="0.495" stop-color="#836944" />
              <stop offset="1" stop-color="#EAA84C" />
            </linearGradient>
            <linearGradient
              id="paint9_linear_3173_18800"
              x1="336.842"
              y1="3.99216"
              x2="352.702"
              y2="11.8314"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#B5915F" />
              <stop offset="0.495" stop-color="#836944" />
              <stop offset="1" stop-color="#EAA84C" />
            </linearGradient>
            <linearGradient
              id="paint10_linear_3173_18800"
              x1="339.109"
              y1="8.01018"
              x2="345.476"
              y2="9.20654"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#B5915F" />
              <stop offset="0.495" stop-color="#836944" />
              <stop offset="1" stop-color="#EAA84C" />
            </linearGradient>
            <linearGradient
              id="paint11_linear_3173_18800"
              x1="339.109"
              y1="8.01018"
              x2="345.476"
              y2="9.20654"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#B5915F" />
              <stop offset="0.495" stop-color="#836944" />
              <stop offset="1" stop-color="#EAA84C" />
            </linearGradient>
            <linearGradient
              id="paint12_linear_3173_18800"
              x1="276.664"
              y1="9.87181"
              x2="362.991"
              y2="55.4293"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#B5915F" />
              <stop offset="0.495" stop-color="#836944" />
              <stop offset="1" stop-color="#EAA84C" />
            </linearGradient>
            <linearGradient
              id="paint13_linear_3173_18800"
              x1="276.664"
              y1="9.87181"
              x2="362.991"
              y2="55.4293"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#B5915F" />
              <stop offset="0.495" stop-color="#836944" />
              <stop offset="1" stop-color="#EAA84C" />
            </linearGradient>
            <linearGradient
              id="paint14_linear_3173_18800"
              x1="282.307"
              y1="3.99216"
              x2="298.167"
              y2="11.8314"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#B5915F" />
              <stop offset="0.495" stop-color="#836944" />
              <stop offset="1" stop-color="#EAA84C" />
            </linearGradient>
            <linearGradient
              id="paint15_linear_3173_18800"
              x1="282.307"
              y1="3.99216"
              x2="298.167"
              y2="11.8314"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#B5915F" />
              <stop offset="0.495" stop-color="#836944" />
              <stop offset="1" stop-color="#EAA84C" />
            </linearGradient>
            <linearGradient
              id="paint16_linear_3173_18800"
              x1="284.387"
              y1="8.01018"
              x2="290.754"
              y2="9.20654"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#B5915F" />
              <stop offset="0.495" stop-color="#836944" />
              <stop offset="1" stop-color="#EAA84C" />
            </linearGradient>
            <linearGradient
              id="paint17_linear_3173_18800"
              x1="284.387"
              y1="8.01018"
              x2="290.754"
              y2="9.20654"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#B5915F" />
              <stop offset="0.495" stop-color="#836944" />
              <stop offset="1" stop-color="#EAA84C" />
            </linearGradient>
            <linearGradient
              id="paint18_linear_3173_18800"
              x1="309.055"
              y1="6.29988"
              x2="328.654"
              y2="14.0849"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#B5915F" />
              <stop offset="0.495" stop-color="#836944" />
              <stop offset="1" stop-color="#EAA84C" />
            </linearGradient>
            <linearGradient
              id="paint19_linear_3173_18800"
              x1="309.055"
              y1="6.29988"
              x2="328.654"
              y2="14.0849"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#B5915F" />
              <stop offset="0.495" stop-color="#836944" />
              <stop offset="1" stop-color="#EAA84C" />
            </linearGradient>
          </defs>
        </svg>
      </Grid>

      <Grid
        container
        alignItems="center"
        justifyContent="center"
        mb={2}
        sx={{ position: "relative" }}
      >
        {/* Center Text */}
        <Grid item textAlign="center">
          <Typography
            fontWeight="400"
            fontSize="32px"
            lineHeight="100%"
            fontFamily="Inter"
            color="#161719"
          >
            Your Onboard Journey Map
          </Typography>

          <Box
            sx={{
              mt: 2,
              display: "flex",
              justifyContent: "center",
              width: "100%",
              mb: 2,
            }}
          >
            <Typography
              fontFamily="Inter"
              fontWeight={400}
              fontSize="16px"
              lineHeight="150%"
              textAlign="center"
              sx={{ color: "#313439", maxWidth: "517px" }}
            >
              A personalized roadmap to your dream college
            </Typography>
          </Box>
        </Grid>

        {/* Plane - absolute right */}
        <Box
          sx={{
            position: "absolute",
            right: 0,
            top: "50%",
            transform: "translateY(-50%)",
          }}
        >
          <svg
            width="62"
            height="43"
            viewBox="0 0 62 43"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M30.4026 13.3963L18.6534 5.15163C17.6405 4.44088 17.6482 2.95451 18.6684 2.25716L21.5115 0.314246C22.0603 -0.0605883 22.775 -0.103388 23.3662 0.203569L43.4891 10.6466C43.97 10.8961 44.5483 10.9095 45.0464 10.6963C52.8298 7.36865 57.5979 6.68858 60.2205 6.69982C61.7186 6.70631 62.5527 8.46332 61.5844 9.58955C58.3435 13.3591 50.0999 16.1948 47.1855 17.1083C46.5441 17.3093 46.0735 17.851 45.9641 18.5064L42.3676 40.0311C42.2574 40.6904 41.7798 41.2312 41.1333 41.4297L36.6097 42.8166C35.3883 43.191 34.1724 42.2183 34.2908 40.9615L35.7448 25.5293C35.8632 24.2712 34.6444 23.298 33.4225 23.6754L19.3887 28.0066C18.9125 28.1536 18.5204 28.4899 18.3068 28.9348L12.049 41.9602C11.8504 42.3735 11.4973 42.6943 11.0635 42.8555L10.9898 42.8832C9.62332 43.3916 8.24533 42.1586 8.62416 40.7669L11.8276 29.0083C12.04 28.2296 11.6908 27.4069 10.9786 27.0087L0.910297 21.3784C-0.34116 20.6785 -0.292252 18.8839 0.995243 18.2553C1.43885 18.0387 1.95328 18.0132 2.41748 18.1839L16.1698 23.2543C16.6567 23.4338 17.1986 23.3961 17.6546 23.151L30.225 16.3897C31.3868 15.7646 31.4824 14.1541 30.4026 13.3963Z"
              fill="#E6DECD"
            />
          </svg>
        </Box>
        {/* Container for plane + line */}
        <Box
          sx={{
            position: "absolute",
            right: 0,
            top: "50%",
            transform: "translateY(-50%)",
          }}
        >
          {/* Plane */}
          <svg
            width="62"
            height="43"
            viewBox="0 0 62 43"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ position: "relative", zIndex: 2 }}
          >
            <path
              d="M30.4026 13.3963L18.6534 5.15163C17.6405 4.44088 17.6482 2.95451 18.6684 2.25716L21.5115 0.314246C22.0603 -0.0605883 22.775 -0.103388 23.3662 0.203569L43.4891 10.6466C43.97 10.8961 44.5483 10.9095 45.0464 10.6963C52.8298 7.36865 57.5979 6.68858 60.2205 6.69982C61.7186 6.70631 62.5527 8.46332 61.5844 9.58955C58.3435 13.3591 50.0999 16.1948 47.1855 17.1083C46.5441 17.3093 46.0735 17.851 45.9641 18.5064L42.3676 40.0311C42.2574 40.6904 41.7798 41.2312 41.1333 41.4297L36.6097 42.8166C35.3883 43.191 34.1724 42.2183 34.2908 40.9615L35.7448 25.5293C35.8632 24.2712 34.6444 23.298 33.4225 23.6754L19.3887 28.0066C18.9125 28.1536 18.5204 28.4899 18.3068 28.9348L12.049 41.9602C11.8504 42.3735 11.4973 42.6943 11.0635 42.8555L10.9898 42.8832C9.62332 43.3916 8.24533 42.1586 8.62416 40.7669L11.8276 29.0083C12.04 28.2296 11.6908 27.4069 10.9786 27.0087L0.910297 21.3784C-0.34116 20.6785 -0.292252 18.8839 0.995243 18.2553C1.43885 18.0387 1.95328 18.0132 2.41748 18.1839L16.1698 23.2543C16.6567 23.4338 17.1986 23.3961 17.6546 23.151L30.225 16.3897C31.3868 15.7646 31.4824 14.1541 30.4026 13.3963Z"
              fill="#E6DECD"
            />
          </svg>

          {/* Line coming from plane */}
          {/* <Box >
          <svg
            width="200"
            height="100"
            viewBox="0 0 200 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{
              position: "absolute",
              top: "50%",
              right: "50px",
              transform: "translateY(-50%)",
              zIndex: 1,
            }}
          >
            <path
              d="M190 1C120 30 60 60 5 95"
              stroke="#E6DECD"
              strokeWidth="2"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeDasharray="12.63 12.63"
            />
          </svg>
          </Box> */}
        </Box>
      </Grid>

      {/* Cards */}
      <Grid container spacing={3} color={"#FFFAF6"}>
        {cards.map((card, index) => (
          <Grid item xs={12} md={4} sm={6} key={index}>
            <Card
              sx={{
                borderRadius: "12px",
                boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                textAlign: "center",
                p: 0,
                backgroundColor: "#FFFAF6",
                border: "1px solid gray",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CardContent>
                <Grid display={"flex"} justifyContent={"center"} gap={1}>
                  <Box mb={1}>{card.icon}</Box>
                  <Typography
                    color={"#161719"}
                    fontFamily={"Inter"}
                    fontSize="18px"
                    variant="subtitle1"
                    fontWeight="400"
                  >
                    {card.title}
                  </Typography>
                </Grid>

                <Typography
                  color={"#313439"}
                  fontFamily={"Inter"}
                  fontSize="13px"
                  variant="subtitle1"
                  fontWeight="400"
                  sx={{ b: 4 }}
                >
                  {card.head}
                </Typography>
                <Grid>
                  <svg
                    width="212"
                    height="8"
                    viewBox="0 0 212 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g opacity="0.15">
                      <path
                        d="M1.45526 4.02981H2.05143C2.26822 4.02981 2.45249 4.10397 2.49585 4.2099C2.49585 4.21343 2.49946 4.2152 2.50668 4.2152C2.60424 4.40588 3.13537 4.42707 3.34132 4.26287C3.52559 4.10926 3.76406 3.98744 3.91581 3.91858C3.94472 3.90446 3.97001 3.88857 3.99169 3.87091H91.542C91.7263 3.87091 91.8672 3.80205 91.8672 3.71201C91.8672 3.62726 91.7263 3.55311 91.542 3.55311H4.02421C4.00253 3.52663 3.97001 3.50014 3.91581 3.47896C3.76406 3.4101 3.52559 3.28827 3.34132 3.13467C3.13537 2.97047 2.60424 2.99166 2.50668 3.17704C2.49946 3.18057 2.49585 3.18411 2.49585 3.18764C2.45249 3.29357 2.26822 3.36772 2.05143 3.36772H1.45526C1.20595 3.36772 1 3.46836 1 3.59019V3.69612V3.80735C1 3.92917 1.20595 4.02981 1.45526 4.02981Z"
                        fill="url(#paint0_linear_3373_10973)"
                        stroke="url(#paint1_linear_3373_10973)"
                      />
                      <path
                        d="M116.966 4.02981H117.589C117.816 4.02981 118.008 4.10397 118.054 4.2099C118.054 4.21343 118.057 4.2152 118.065 4.2152C118.167 4.40588 118.722 4.42707 118.937 4.26287C119.13 4.10926 119.379 3.98744 119.538 3.91858C119.568 3.90446 119.594 3.88857 119.617 3.87091H211.121C211.314 3.87091 211.461 3.80205 211.461 3.71201C211.461 3.62726 211.314 3.55311 211.121 3.55311H119.651C119.628 3.52663 119.594 3.50014 119.538 3.47896C119.379 3.4101 119.13 3.28827 118.937 3.13467C118.722 2.97047 118.167 2.99166 118.065 3.17704C118.057 3.18057 118.054 3.18411 118.054 3.18764C118.008 3.29357 117.816 3.36772 117.589 3.36772H116.966C116.705 3.36772 116.49 3.46836 116.49 3.59019V3.69612V3.80735C116.49 3.92917 116.705 4.02981 116.966 4.02981Z"
                        fill="url(#paint2_linear_3373_10973)"
                        stroke="url(#paint3_linear_3373_10973)"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M104.193 4.76233C103.925 4.76233 103.709 4.47191 103.709 4.11235C103.709 3.75279 103.925 3.45776 104.193 3.45776C104.464 3.45776 104.68 3.75279 104.68 4.11235C104.68 4.47191 104.464 4.76233 104.193 4.76233ZM104.464 4.11235C104.464 3.91413 104.344 3.75279 104.193 3.75279C104.045 3.75279 103.925 3.91413 103.925 4.11235C103.925 4.31057 104.045 4.47191 104.193 4.47191C104.344 4.47191 104.464 4.31057 104.464 4.11235Z"
                        fill="url(#paint4_linear_3373_10973)"
                        stroke="url(#paint5_linear_3373_10973)"
                      />
                      <path
                        d="M104.089 6.6101C104.089 6.68846 104.14 6.74378 104.195 6.74378C104.25 6.73917 104.295 6.67463 104.295 6.60088C104.281 6.08919 104.456 5.55907 104.772 5.14419C105.039 4.79845 105.396 4.53109 105.863 4.32365C106.793 3.9226 107.781 3.91799 108.625 3.96409C109.123 3.98713 109.703 4.04245 110.259 4.22684C110.516 4.31443 110.774 4.43428 111.021 4.54953C111.292 4.66938 111.566 4.79385 111.851 4.88604C113.09 5.2917 114.476 4.97824 115.554 4.05628C115.556 4.05628 115.557 4.05628 115.557 4.05628C115.578 4.03323 116.106 3.55382 116.151 2.77937C116.178 2.29996 116.017 1.76983 115.739 1.4241C115.574 1.22127 115.31 1 114.922 1C114.847 1 114.768 1.00922 114.686 1.02766C114.233 1.12446 113.879 1.57622 113.783 2.1801C113.694 2.72867 113.841 3.24496 114.167 3.53538C114.212 3.57686 114.277 3.55843 114.308 3.49389C114.339 3.42935 114.325 3.34638 114.277 3.30028C114.027 3.07901 113.913 2.67335 113.982 2.24003C114.061 1.74678 114.349 1.378 114.716 1.29964C115.156 1.20744 115.437 1.4241 115.598 1.62693C115.866 1.95422 115.965 2.42903 115.945 2.75632C115.911 3.38786 115.461 3.80735 115.444 3.82579C114.411 4.70626 113.086 5.0059 111.899 4.61867C111.625 4.53109 111.353 4.40662 111.089 4.28677C110.835 4.17153 110.575 4.05167 110.307 3.95948C109.734 3.76587 109.14 3.71516 108.636 3.6875C108.426 3.67367 108.21 3.66445 107.987 3.66445C107.287 3.66445 106.529 3.74743 105.801 4.0655C105.3 4.28216 104.919 4.56797 104.631 4.94597C104.271 5.41616 104.072 6.02005 104.089 6.6101Z"
                        fill="url(#paint6_linear_3373_10973)"
                        stroke="url(#paint7_linear_3373_10973)"
                      />
                      <path
                        d="M113.147 2.47576C112.803 2.47576 112.474 2.25449 112.162 1.80735C112.12 1.75203 112.124 1.65983 112.169 1.60451C112.21 1.5492 112.278 1.5492 112.32 1.60912C112.608 2.01939 112.903 2.21301 113.201 2.18535C113.72 2.13464 114.09 1.44778 114.094 1.43856C114.128 1.37403 114.197 1.3602 114.245 1.40629C114.293 1.45239 114.306 1.54459 114.269 1.60912C114.251 1.64139 113.836 2.41584 113.219 2.47576C113.193 2.47576 113.169 2.47576 113.147 2.47576Z"
                        fill="url(#paint8_linear_3373_10973)"
                        stroke="url(#paint9_linear_3373_10973)"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M113.241 3.7381C113.042 3.7381 112.881 3.52605 112.881 3.25868C112.881 2.99132 113.042 2.77466 113.241 2.77466C113.44 2.77466 113.601 2.99132 113.601 3.25868C113.601 3.52605 113.44 3.7381 113.241 3.7381ZM113.385 3.25868C113.385 3.15266 113.32 3.06507 113.241 3.06507C113.162 3.06507 113.097 3.15266 113.097 3.25868C113.097 3.36471 113.162 3.44769 113.241 3.44769C113.32 3.44769 113.385 3.36471 113.385 3.25868Z"
                        fill="url(#paint10_linear_3373_10973)"
                        stroke="url(#paint11_linear_3373_10973)"
                      />
                      <path
                        d="M104.284 6.6101C104.284 6.68846 104.232 6.74378 104.177 6.74378C104.122 6.73917 104.078 6.67463 104.078 6.60088C104.091 6.08919 103.92 5.55907 103.601 5.14419C103.333 4.79845 102.976 4.53109 102.51 4.32365C101.58 3.9226 100.591 3.91799 99.7471 3.96409C99.2496 3.98713 98.6696 4.04245 98.1137 4.22684C97.8564 4.31443 97.599 4.43428 97.3519 4.54953C97.0808 4.66938 96.8063 4.79385 96.5249 4.88604C95.2827 5.2917 93.8964 4.97824 92.8189 4.05628C92.8166 4.05628 92.8154 4.05628 92.8154 4.05628C92.7948 4.03323 92.2664 3.55382 92.2218 2.77937C92.1943 2.29996 92.3556 1.76983 92.6336 1.4241C92.7983 1.22127 93.0625 1 93.4503 1C93.5235 1 93.6024 1.00922 93.687 1.02766C94.14 1.12446 94.4934 1.57622 94.5895 2.1801C94.6788 2.72867 94.5312 3.24496 94.2052 3.53538C94.1606 3.57686 94.0954 3.55843 94.0645 3.49389C94.0336 3.42935 94.0473 3.34638 94.0954 3.30028C94.3459 3.07901 94.4591 2.67335 94.3905 2.24003C94.3116 1.74678 94.0233 1.378 93.6562 1.29964C93.2169 1.20744 92.9355 1.4241 92.7742 1.62693C92.5066 1.95422 92.4071 2.42903 92.4277 2.75632C92.462 3.38786 92.9115 3.80735 92.9287 3.82579C93.9616 4.70626 95.2861 5.0059 96.4769 4.61867C96.748 4.53109 97.0225 4.40662 97.2833 4.28677C97.5372 4.17153 97.798 4.05167 98.0657 3.95948C98.6387 3.76587 99.2324 3.71516 99.7368 3.6875C99.9462 3.67367 100.162 3.66445 100.385 3.66445C101.085 3.66445 101.844 3.74743 102.571 4.0655C103.072 4.28216 103.453 4.56797 103.741 4.94597C104.102 5.41616 104.301 6.02005 104.284 6.6101Z"
                        fill="url(#paint12_linear_3373_10973)"
                        stroke="url(#paint13_linear_3373_10973)"
                      />
                      <path
                        d="M95.2351 2.47576C95.21 2.47576 95.1848 2.47576 95.1596 2.47576C94.542 2.41584 94.1267 1.64139 94.1096 1.60912C94.0718 1.54459 94.0856 1.45239 94.1336 1.40629C94.1816 1.3602 94.2503 1.37403 94.2846 1.43856C94.2915 1.45239 94.6621 2.13925 95.1768 2.18535C95.4753 2.2084 95.7704 2.01939 96.0587 1.60912C96.0999 1.5492 96.1685 1.5492 96.2097 1.60451C96.2543 1.65983 96.2577 1.75203 96.2165 1.80735C95.9043 2.25449 95.5749 2.47576 95.2351 2.47576Z"
                        fill="url(#paint14_linear_3373_10973)"
                        stroke="url(#paint15_linear_3373_10973)"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M95.1337 3.7381C94.9347 3.7381 94.7734 3.52605 94.7734 3.25868C94.7734 2.99132 94.9347 2.77466 95.1337 2.77466C95.3328 2.77466 95.4941 2.99132 95.4941 3.25868C95.4941 3.52605 95.3328 3.7381 95.1337 3.7381ZM95.2779 3.25868C95.2779 3.15266 95.2127 3.06507 95.1337 3.06507C95.0548 3.06507 94.9896 3.15266 94.9896 3.25868C94.9896 3.36471 95.0548 3.44769 95.1337 3.44769C95.2127 3.44769 95.2779 3.36471 95.2779 3.25868Z"
                        fill="url(#paint16_linear_3373_10973)"
                        stroke="url(#paint17_linear_3373_10973)"
                      />
                      <path
                        d="M103.029 3.46945C103.039 3.46945 103.859 3.60775 104.182 2.58438C104.504 3.60775 105.324 3.46945 105.335 3.46945C105.39 3.46023 105.431 3.38648 105.421 3.31272C105.414 3.23896 105.362 3.18365 105.307 3.19287C105.27 3.20209 104.443 3.34038 104.285 2.06808C104.285 2.06501 104.285 2.06347 104.285 2.06347C104.295 1.98971 104.254 1.92057 104.199 1.90674C104.194 1.90674 104.19 1.90674 104.185 1.90674C104.183 1.90674 104.182 1.90674 104.182 1.90674C104.182 1.90674 104.181 1.90674 104.178 1.90674C104.174 1.90674 104.169 1.90674 104.165 1.90674C104.106 1.92057 104.069 1.98971 104.079 2.06347C104.079 2.06347 104.079 2.06501 104.079 2.06808C103.921 3.33116 103.094 3.20209 103.056 3.19287C103.001 3.18365 102.95 3.23896 102.943 3.31272C102.933 3.38648 102.974 3.46023 103.029 3.46945Z"
                        fill="url(#paint18_linear_3373_10973)"
                        stroke="url(#paint19_linear_3373_10973)"
                      />
                    </g>
                    <defs>
                      <linearGradient
                        id="paint0_linear_3373_10973"
                        x1="1"
                        y1="3.69852"
                        x2="1.95815"
                        y2="19.904"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#B5915F" />
                        <stop offset="0.495" stop-color="#836944" />
                        <stop offset="1" stop-color="#EAA84C" />
                      </linearGradient>
                      <linearGradient
                        id="paint1_linear_3373_10973"
                        x1="1"
                        y1="3.69852"
                        x2="1.95815"
                        y2="19.904"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#B5915F" />
                        <stop offset="0.495" stop-color="#836944" />
                        <stop offset="1" stop-color="#EAA84C" />
                      </linearGradient>
                      <linearGradient
                        id="paint2_linear_3373_10973"
                        x1="116.49"
                        y1="3.69852"
                        x2="117.407"
                        y2="19.9088"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#B5915F" />
                        <stop offset="0.495" stop-color="#836944" />
                        <stop offset="1" stop-color="#EAA84C" />
                      </linearGradient>
                      <linearGradient
                        id="paint3_linear_3373_10973"
                        x1="116.49"
                        y1="3.69852"
                        x2="117.407"
                        y2="19.9088"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#B5915F" />
                        <stop offset="0.495" stop-color="#836944" />
                        <stop offset="1" stop-color="#EAA84C" />
                      </linearGradient>
                      <linearGradient
                        id="paint4_linear_3373_10973"
                        x1="103.709"
                        y1="4.11005"
                        x2="106.549"
                        y2="4.64119"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#B5915F" />
                        <stop offset="0.495" stop-color="#836944" />
                        <stop offset="1" stop-color="#EAA84C" />
                      </linearGradient>
                      <linearGradient
                        id="paint5_linear_3373_10973"
                        x1="103.709"
                        y1="4.11005"
                        x2="106.549"
                        y2="4.64119"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#B5915F" />
                        <stop offset="0.495" stop-color="#836944" />
                        <stop offset="1" stop-color="#EAA84C" />
                      </linearGradient>
                      <linearGradient
                        id="paint6_linear_3373_10973"
                        x1="104.088"
                        y1="3.87189"
                        x2="132.654"
                        y2="18.9474"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#B5915F" />
                        <stop offset="0.495" stop-color="#836944" />
                        <stop offset="1" stop-color="#EAA84C" />
                      </linearGradient>
                      <linearGradient
                        id="paint7_linear_3373_10973"
                        x1="104.088"
                        y1="3.87189"
                        x2="132.654"
                        y2="18.9474"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#B5915F" />
                        <stop offset="0.495" stop-color="#836944" />
                        <stop offset="1" stop-color="#EAA84C" />
                      </linearGradient>
                      <linearGradient
                        id="paint8_linear_3373_10973"
                        x1="112.133"
                        y1="1.92746"
                        x2="117.381"
                        y2="4.52155"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#B5915F" />
                        <stop offset="0.495" stop-color="#836944" />
                        <stop offset="1" stop-color="#EAA84C" />
                      </linearGradient>
                      <linearGradient
                        id="paint9_linear_3373_10973"
                        x1="112.133"
                        y1="1.92746"
                        x2="117.381"
                        y2="4.52155"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#B5915F" />
                        <stop offset="0.495" stop-color="#836944" />
                        <stop offset="1" stop-color="#EAA84C" />
                      </linearGradient>
                      <linearGradient
                        id="paint10_linear_3373_10973"
                        x1="112.881"
                        y1="3.25638"
                        x2="114.988"
                        y2="3.65227"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#B5915F" />
                        <stop offset="0.495" stop-color="#836944" />
                        <stop offset="1" stop-color="#EAA84C" />
                      </linearGradient>
                      <linearGradient
                        id="paint11_linear_3373_10973"
                        x1="112.881"
                        y1="3.25638"
                        x2="114.988"
                        y2="3.65227"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#B5915F" />
                        <stop offset="0.495" stop-color="#836944" />
                        <stop offset="1" stop-color="#EAA84C" />
                      </linearGradient>
                      <linearGradient
                        id="paint12_linear_3373_10973"
                        x1="92.2188"
                        y1="3.87189"
                        x2="120.785"
                        y2="18.9474"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#B5915F" />
                        <stop offset="0.495" stop-color="#836944" />
                        <stop offset="1" stop-color="#EAA84C" />
                      </linearGradient>
                      <linearGradient
                        id="paint13_linear_3373_10973"
                        x1="92.2188"
                        y1="3.87189"
                        x2="120.785"
                        y2="18.9474"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#B5915F" />
                        <stop offset="0.495" stop-color="#836944" />
                        <stop offset="1" stop-color="#EAA84C" />
                      </linearGradient>
                      <linearGradient
                        id="paint14_linear_3373_10973"
                        x1="94.0879"
                        y1="1.92746"
                        x2="99.3363"
                        y2="4.52155"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#B5915F" />
                        <stop offset="0.495" stop-color="#836944" />
                        <stop offset="1" stop-color="#EAA84C" />
                      </linearGradient>
                      <linearGradient
                        id="paint15_linear_3373_10973"
                        x1="94.0879"
                        y1="1.92746"
                        x2="99.3363"
                        y2="4.52155"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#B5915F" />
                        <stop offset="0.495" stop-color="#836944" />
                        <stop offset="1" stop-color="#EAA84C" />
                      </linearGradient>
                      <linearGradient
                        id="paint16_linear_3373_10973"
                        x1="94.7734"
                        y1="3.25638"
                        x2="96.8803"
                        y2="3.65227"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#B5915F" />
                        <stop offset="0.495" stop-color="#836944" />
                        <stop offset="1" stop-color="#EAA84C" />
                      </linearGradient>
                      <linearGradient
                        id="paint17_linear_3373_10973"
                        x1="94.7734"
                        y1="3.25638"
                        x2="96.8803"
                        y2="3.65227"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#B5915F" />
                        <stop offset="0.495" stop-color="#836944" />
                        <stop offset="1" stop-color="#EAA84C" />
                      </linearGradient>
                      <linearGradient
                        id="paint18_linear_3373_10973"
                        x1="102.941"
                        y1="2.69123"
                        x2="109.427"
                        y2="5.2674"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#B5915F" />
                        <stop offset="0.495" stop-color="#836944" />
                        <stop offset="1" stop-color="#EAA84C" />
                      </linearGradient>
                      <linearGradient
                        id="paint19_linear_3373_10973"
                        x1="102.941"
                        y1="2.69123"
                        x2="109.427"
                        y2="5.2674"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#B5915F" />
                        <stop offset="0.495" stop-color="#836944" />
                        <stop offset="1" stop-color="#EAA84C" />
                      </linearGradient>
                    </defs>
                  </svg>
                </Grid>
                <Typography
                  fontFamily={"Lato"}
                  fontWeight={"500"}
                  fontSize={"14px"}
                  variant="body2"
                  color="#3F424C"
                  sx={{ mt: 1, mb: 2 }}
                >
                  {card.desc}
                </Typography>
                <Button
                  // onClick={() => navigate("/personality-quiz")}
                  disabled={
                    card.title === "Personality Quiz" && alreadySubmitted
                  }
                  onClick={() => handleStart(card)}
                  variant="contained"
                  sx={{
                    backgroundColor: "#572575",
                    "&:hover": { backgroundColor: "#572575" },
                    borderRadius: "8px",
                    px: 3,
                    // fontFamily: "Inter",
                    fontWeight: "700",
                    // fontSize: "14px",
                  }}
                >
                  {card.title === "Personality Quiz" && alreadySubmitted
                    ? "Completed"
                    : "Start Now"}
                </Button>
                {card.modal && openModal === card.title && card.modal}
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Dialog>
  );
};

export default OnboardingModal;
